<template>
  <el-upload
    class="sky-hc-upload__uploader"
    :class="uploadClass"
    accept
    action=""
    :auto-upload="true"
    :multiple="false"
    :show-file-list="false"
    :httpRequest="handleUploadFile"
  >
    <div v-if="imgUrl" class="sky-hc-upload__img-wrapper">
      <i v-if="hasDel" class="el-icon-close sky-hc-upload__icon-del" @click="handleDelImg"></i>
      <img :src="imgUrl" width="100%" height="100%" />
    </div>
    <template v-else>
      <i class="el-icon-plus sky-hc-upload__uploader-icon"></i>
      <div class="sky-hc-upload__uploader-txt1">{{ $t('setting.uploadImg') }}</div>
      <div class="sky-hc-upload__uploader-txt2">{{ $t('setting.imgSize') }}{{ size }}</div>
    </template>
  </el-upload>
</template>
<script>
import { Upload } from 'element-ui'

import { uploadImg } from '@/api/setting'
export default {
  name: 'Upload',
  props: {
    uploadClass: {
      type: String,
      default() {
        return ''
      }
    },
    imgUrl: {
      type: String,
      default() {
        return ''
      }
    },
    size: {
      type: String,
      default() {
        return '1920*440'
      }
    },
    hasDel: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  components: {
    [Upload.name]: Upload
  },
  methods: {
    handleUploadFile(params) {
      const formData = new FormData()
      formData.append('file', params.file)
      uploadImg(formData).then(response => {
        this.$emit('handleUploadFile', response.data.content.url)
      })
    },
    handleDelImg() {
      this.$emit('handleDelImg')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-upload) {
  @include e(uploader) {
    border: 1px dashed $--color-primary;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @include e(uploader-index) {
    height: 386px;
  }
  @include e(uploader-icon) {
    font-size: 60px;
    color: $--color-primary;
  }
  @include e(img-wrapper) {
    width: 100%;
    height: 100%;
    position: relative;
  }
  @include e(icon-del) {
    position: absolute;
    right: 10px;
    display: block;
    top: 10px;
    font-size: 20px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    &:hover {
      color: $--color-primary;
    }
  }
}
</style>
<style lang="scss">
.sky-hc-upload__uploader {
  & .el-upload {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.sky-hc-upload__uploader-index {
  height: 386px;
}
.sky-hc-upload__uploader-article {
  height: 148px;
  width: 398px;
  .sky-hc-upload__uploader-icon {
    font-size: 50px;
  }
}
</style>
